import types from './types';

const initialState = {
  child: {
    age: 10,
  },
  infant: {
    age: 5,
  },
  baby: {
    age: 1,
  },
};

function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case types.GET_AGES: {
      const {
        // eslint-disable-next-line no-unused-vars
        ages: { childAge, infantAge, babyAge },
      } = action;

      return {
        child: {
          age: childAge,
        },
        infant: {
          age: infantAge,
        },
        baby: {
          age: 1,
        },
      };
    }
    default: {
      return state;
    }
  }
}

export default reducer;
